import React, { Dispatch, Ref, SetStateAction, forwardRef, useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { initialProductData } from "@src/hooks/stateLand/useStateLand";
import InfoIcon from "./InfoIcon";
import PolygonIcon from "./PolygonIcon";

interface SubscriptionContentsProps {
    id: string;
    list: any[];
    selectedProductInfo: any;
    setSelectedProductInfo: Dispatch<SetStateAction<any>>;
    selectedProductList: any[];
    title: string;
    primaryColor: string;

    yearDisplayText?: string;
    yearDisplaySubText?: string;
    saleText?: string;
}

export const getMonthsFromString = (str: string): number | null => {
    try {
        const parts = str.split("개월");

        const beforePart = parts[0];
        let numberStr = "";

        for (let i = beforePart.length - 1; i >= 0; i--) {
            const char = beforePart[i];
            if (!isNaN(parseInt(char, 10))) {
                numberStr = char + numberStr;
            } else {
                break;
            }
        }

        return numberStr ? parseInt(numberStr, 10) : null;
    } catch (e) {
        return null;
    }
};

const PremiumProduct = forwardRef(
    (
        {
            id,
            list,
            selectedProductInfo,
            setSelectedProductInfo,
            selectedProductList,
            title,
            primaryColor,

            yearDisplayText,
            yearDisplaySubText,
            saleText,
        }: SubscriptionContentsProps,
        scrollRef: Ref<HTMLDivElement>,
    ) => {
        const yearlyProduct = list?.filter((item) => item?.serveDurationType === "year");
        const monthlyProduct = list
            ?.filter((item) => item?.serveDurationType === "month")
            ?.sort((a, b) => {
                return b?.term1DiscountedPrice - a?.term1DiscountedPrice;
            });

        const [selectMonthlyItem, setSelectMonthlyItem] = useState(monthlyProduct[0]);
        const [isShowMaintenanceConditions, setIsShowMaintenanceConditions] = useState<boolean>(false);
        const [isShowYearlyRegularPrice, setIsShowYearlyRegularPrice] = useState<boolean>(false);
        const [isShowMonthlyRegularPrice, setIsShowMonthlyRegularPrice] = useState<boolean>(false);

        useEffect(() => {
            if (selectMonthlyItem == null || selectMonthlyItem === undefined) {
                setSelectMonthlyItem(monthlyProduct[0]);
            }
        }, [monthlyProduct]);

        console.log(selectedProductInfo);

        return (
            <Container ref={scrollRef} id={id}>
                <DescriptionBox>
                    <SubsTitle $primaryColor={primaryColor}>{title}</SubsTitle>

                    <Description
                        dangerouslySetInnerHTML={{
                            __html:
                                list &&
                                (list[0]?.displayDescription
                                    .replaceAll("background-color: #ffffff;", "")
                                    .replaceAll("background-color", "padding: 0px 4px; background-color") ??
                                    ""),
                        }}
                    />
                </DescriptionBox>

                <ProductBox>
                    {/* 년간 결제 */}
                    <YearlyProduct>
                        <ProductTitle>연 구독권</ProductTitle>
                        <YearlyProductDescription>
                            <div className="텍스트">
                                <div className="yearDisplayText">{yearDisplayText}</div>
                                <div className="yearDisplaySubText">{yearDisplaySubText}</div>
                            </div>
                        </YearlyProductDescription>

                        <ProductItem
                            $selected={selectedProductList?.[0]?.no === yearlyProduct[0]?.no}
                            $primaryColor={primaryColor}
                            onClick={() => {
                                if (selectedProductList?.[0]?.no === yearlyProduct[0]?.no) {
                                    setSelectedProductInfo(initialProductData);
                                } else {
                                    setSelectedProductInfo(yearlyProduct[0]);
                                }
                            }}
                        >
                            <Pricebox>
                                <Price>
                                    {saleText !== "" && <div className="할인율">{saleText}</div>}
                                    <div className="기존가격">
                                        기존 {yearlyProduct[0]?.term2DiscountedPrice?.toLocaleString()}원
                                        <InfoIconBox>
                                            <InfoIconBody $show={isShowYearlyRegularPrice}>
                                                <div className="InfoText">
                                                    {`정가 ${yearlyProduct[0]?.price?.toLocaleString()}원`}
                                                </div>

                                                <div className="PolygonIcon">
                                                    <PolygonIcon />
                                                </div>
                                            </InfoIconBody>

                                            <div
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                                onClick={() => {
                                                    setIsShowYearlyRegularPrice(!isShowYearlyRegularPrice);
                                                }}
                                            >
                                                <InfoIcon />
                                            </div>
                                        </InfoIconBox>
                                    </div>
                                    <div className="결제가격">
                                        연 {yearlyProduct[0]?.term1DiscountedPrice?.toLocaleString()}원
                                    </div>
                                    <div className="나눈가격">
                                        (환산 시 월{" "}
                                        {(Math.floor(yearlyProduct[0]?.term1DiscountedPrice / 12 / 1000) * 1000).toLocaleString()}
                                        원)
                                    </div>
                                </Price>

                                <PriceInfoBox>
                                    <PriceInfo>
                                        <div className="좌측">결제방식</div>
                                        <div className="우측">매년 결제</div>
                                    </PriceInfo>
                                </PriceInfoBox>
                            </Pricebox>

                            <div className="유혹문구">가장 합리적인 가격으로 시작해보세요.</div>
                        </ProductItem>
                    </YearlyProduct>

                    {/* 월 결제 */}
                    <MonthlyProduct>
                        <ProductTitle>월 구독권</ProductTitle>
                        <MonthlyProductDescription>
                            <div className="유지조건">구독 유지 조건</div>
                            {monthlyProduct.length > 0 && (
                                <div className="선택버튼">
                                    {monthlyProduct.map((item) => (
                                        <button
                                            key={item.no}
                                            onClick={() => {
                                                setSelectMonthlyItem(item);
                                                setSelectedProductInfo(item);
                                            }}
                                            style={{
                                                border: `2px solid ${
                                                    selectMonthlyItem?.no === item.no &&
                                                    selectedProductList?.[0]?.no === selectMonthlyItem?.no
                                                        ? primaryColor
                                                        : "#c9c9c9"
                                                }`,
                                            }}
                                        >
                                            {getMonthsFromString(item.name)}개월
                                        </button>
                                    ))}
                                </div>
                            )}
                        </MonthlyProductDescription>

                        <ProductItem
                            $selected={selectedProductList?.[0]?.no === selectMonthlyItem?.no}
                            $primaryColor={primaryColor}
                            onClick={() => {
                                if (selectedProductList?.[0]?.no === selectMonthlyItem?.no) {
                                    setSelectedProductInfo(initialProductData);
                                } else {
                                    setSelectedProductInfo(selectMonthlyItem);
                                }
                            }}
                        >
                            <Pricebox>
                                <Price>
                                    <div className="기존가격">
                                        기존 {selectMonthlyItem?.term2DiscountedPrice?.toLocaleString()}원
                                        <InfoIconBox>
                                            <InfoIconBody $show={isShowMonthlyRegularPrice}>
                                                <div className="InfoText">
                                                    {`정가 ${selectMonthlyItem?.price?.toLocaleString()}원`}
                                                </div>

                                                <div className="PolygonIcon">
                                                    <PolygonIcon />
                                                </div>
                                            </InfoIconBody>

                                            <div
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                                onClick={() => {
                                                    setIsShowMonthlyRegularPrice(!isShowMonthlyRegularPrice);
                                                }}
                                            >
                                                <InfoIcon />
                                            </div>
                                        </InfoIconBox>
                                    </div>
                                    <div className="결제가격">
                                        월 {selectMonthlyItem?.term1DiscountedPrice?.toLocaleString()}원
                                    </div>
                                    <div className="나눈가격">
                                        (연 {Math.floor(selectMonthlyItem?.term1DiscountedPrice * 12).toLocaleString()}원)
                                    </div>
                                </Price>

                                <PriceInfoBox>
                                    <PriceInfo>
                                        <div className="좌측">결제방식</div>
                                        <div className="우측">매월 결제</div>
                                    </PriceInfo>
                                    <PriceInfo>
                                        <MaintenanceConditions $show={isShowMaintenanceConditions}>
                                            <div className="InfoText">
                                                12개월 이하의 월 구독권 사용자는 <br />
                                                해지 시 정가기준의 위약금이 발생합니다.
                                            </div>

                                            <div className="PolygonIcon">
                                                <PolygonIcon />
                                            </div>
                                        </MaintenanceConditions>

                                        <div className="좌측">
                                            <div>구독유지 조건</div>
                                            <div
                                                onClick={() => {
                                                    setIsShowMaintenanceConditions(!isShowMaintenanceConditions);
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <InfoIcon />
                                            </div>
                                        </div>
                                        <div className="우측">최소 {getMonthsFromString(selectMonthlyItem?.name)}개월 유지</div>
                                    </PriceInfo>
                                </PriceInfoBox>
                            </Pricebox>

                            <div className="유혹문구">
                                연 구독이 부담스럽다면, {getMonthsFromString(selectMonthlyItem?.name)}개월로 가볍게 시작해보세요.
                            </div>
                        </ProductItem>
                    </MonthlyProduct>
                </ProductBox>
            </Container>
        );
    },
);

PremiumProduct.displayName = "PremiumProduct";

const Container = styled.div`
    box-sizing: border-box;
    padding: 20px 14px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    scroll-margin-top: 1000px;
`;

const DescriptionBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .commonImage {
        position: absolute;
        left: -109px;
    }
`;

const Description = styled.div`
    margin-top: 8px;
    ul {
        list-style: unset;
        li {
            list-style: unset;
            margin-left: 22px;
            margin-bottom: 8px;
            list-style-position: outside;
            text-align: left !important;
            & > span {
                font-weight: 700;
                display: inline-block;
            }
        }
    }
`;

const SubsTitle = styled.div<{ $primaryColor: string }>`
    color: ${({ $primaryColor }) => $primaryColor};
    font-size: 34px;
    font-style: normal;
    font-weight: 550;
    line-height: 62px;
`;

const ProductBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

const YearlyProduct = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const MonthlyProduct = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ProductTitle = styled.div`
    text-align: center;
    color: #282828;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
`;

const YearlyProductDescription = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .텍스트 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 18px 0;

        .yearDisplayText {
            color: #000;
            text-align: center;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        .yearDisplaySubText {
            color: #000;
            text-align: center;
            font-size: 22px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
`;

const MonthlyProductDescription = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .유지조건 {
        color: #757575;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
    }

    .선택버튼 {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 21px;

        button {
            width: 100%;
            padding: 14px 30px;
            cursor: pointer;

            border-radius: 12px;
            background: #fff;
            box-shadow: 2px 2px 6px 0 rgba(4, 0, 14, 0.14);

            color: #282828;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
        }
    }
`;

const ProductItem = styled.div<{ $selected: boolean; $primaryColor: string }>`
    height: 266px;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;

    border-radius: 14px;
    border: ${(props) => (props.$selected ? `2px solid ${props.$primaryColor}` : "2px solid #c9c9c9")};
    background: #fff;
    box-shadow: 2px 2px 6px 0 rgba(4, 0, 14, 0.14);

    .할인율 {
        width: fit-content;
        padding: 6px 10px;

        border-radius: 5px;
        background-color: ${(props) => props.$primaryColor};

        color: #fff;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .기존가격 {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #a3a3a3;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        text-decoration-line: line-through;
    }

    .결제가격 {
        color: #282828;
        text-align: center;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
    }

    .나눈가격 {
        color: #0c002c;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }

    .유혹문구 {
        color: ${(props) => props.$primaryColor};
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }
`;

const Pricebox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
`;

const Price = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

const InfoIconBox = styled.div`
    position: relative;
`;

const InfoIconBody = styled.div<{ $show: boolean }>`
    position: absolute;
    bottom: 38px;
    right: -47px;
    padding: 12px 14px;

    background-color: #000;
    border-radius: 12px;

    opacity: ${(props) => (props.$show ? 1 : 0)};
    visibility: ${(props) => (props.$show ? "visible" : "hidden")};
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

    .InfoText {
        white-space: nowrap;
        color: #fff;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }

    .PolygonIcon {
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

const PriceInfoBox = styled.div`
    width: 100%;
`;

const PriceInfo = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 14px 0;

    border-top: 0.5px solid #e0e0e0;

    .좌측 {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        color: #515151;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }

    .우측 {
        color: #000;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
    }
`;

const MaintenanceConditions = styled.div<{ $show: boolean }>`
    position: relative;
    position: absolute;
    top: -64px;
    left: -10px;
    padding: 12px 14px;

    background-color: #000;
    border-radius: 12px;

    opacity: ${(props) => (props.$show ? 1 : 0)};
    visibility: ${(props) => (props.$show ? "visible" : "hidden")};
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

    .InfoText {
        color: #fff;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }

    .PolygonIcon {
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

export default PremiumProduct;
